/**
 * Конфигурация DaData API
 * API ключ берется из environment variables
 */

export interface DaDataConfig {
  baseUrl: string;
  apiKey: string;
  defaultCount: number;
  minQueryLength: number;
}

export const DADATA_CONFIG: DaDataConfig = {
  baseUrl: "https://suggestions.dadata.ru/suggestions/api/4_1/rs",
  apiKey: process.env.REACT_APP_DADATA_API_KEY || "",
  defaultCount: 5,
  minQueryLength: 2,
};

/**
 * Получить заголовки для запросов к DaData API
 */
export const getDaDataHeaders = (): Record<string, string> => ({
  "Content-Type": "application/json",
  Accept: "application/json",
  Authorization: `Token ${DADATA_CONFIG.apiKey}`,
});
